export enum HashimotoTestMeasurementFieldEnum {
  TSH = 'tsh',
  FT3 = 'ft3',
  FT4 = 'ft4',
  ANTI_TG = 'antiTg',
  ANTI_TPO = 'antiTpo',
}

export enum HashimotoTestMeasurementFieldEnumToRemove {
  tsh = 'TSH',
  ft3 = 'FT3',
  ft4 = 'FT4',
  antiTg = 'ANTI_TG',
  antiTpo = 'ANTI_TPO',
}

export type TestMeasurement = {
  value?: number;
  testedAt: string;
};
